/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export enum IWasmSynthesizerWorkerStatus {
	RUNNING = 'RUNNING',
	FINISHED = 'FINISHED',
	ERROR = 'ERROR',
	TERMINATING = 'TERMINATING',
	TERMINATED = 'TERMINATED',
}
